<script setup lang="ts">
import AlertIcon from '~theme/assets/icons/outline/alert-triangle.svg?component';
import CheckIcon from '~theme/assets/icons/outline/checkmark-circle.svg?component';

withDefaults(
  defineProps<{
    results?: ValidationError[];
    validMessage: string;
  }>(),
  {
    results: () => [],
  }
);
</script>

<template>
  <ul :class="$style.list">
    <template v-if="results.length === 0">
      <li :class="[$style.list__item, $style.result, $style['result--valid']]">
        <CheckIcon :class="$style.result__icon" />
        <span :class="$style.result__message">{{ validMessage }}</span>
      </li>
    </template>
    <template v-else>
      <li
        v-for="(item, index) in results"
        :key="index"
        :class="[$style.list__item, $style.result]"
      >
        <AlertIcon :class="$style.result__icon" />
        <span :class="$style.result__message">{{ item.errorMessage }}</span>
      </li>
    </template>
  </ul>
</template>

<style lang="scss" module>
.list {
  &__item {
    &:nth-child(n + 2) {
      margin-top: 4px;
    }
  }
}

.result {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: $color-caution-accent;

  &--valid {
    color: $color-success-accent;
  }

  &__icon {
    width: auto;
    height: 18px;
  }

  &__message {
    font-size: 13px;
    line-height: 18px;
    transition: color $transition-interaction;

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}
</style>
